var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.orgComponent === "orgchart"
        ? [
            _c(
              "div",
              { class: [_vm.hidelines ? "hidelines" : ""] },
              [
                _c("organization-chart", {
                  attrs: { datasource: _vm.datasource },
                  on: { "node-click": _vm.nodeClick },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ nodeData }) {
                          return [
                            _c("div", [
                              _vm.boxStyle === "simple"
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "title",
                                        style: {
                                          "background-color": nodeData.color
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-users symbol"
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(nodeData.name) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm.boxStyle === "ibiden"
                                ? _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "square-container" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "square",
                                            class: nodeData.selected
                                              ? ["selected"]
                                              : [],
                                            style: {
                                              width:
                                                (nodeData.state.expanded
                                                  ? 500
                                                  : 64) + "px"
                                            }
                                          },
                                          [
                                            _c("div", [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-users symbol"
                                              })
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(nodeData.name) +
                                                  "\n                                    "
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      "\n                            Unsupported box style " +
                                        _vm._s(_vm.boxStyle) +
                                        "\n                        "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    479122427
                  )
                })
              ],
              1
            )
          ]
        : _vm.orgComponent === "metrotiles"
        ? [
            _c(
              "div",
              { staticClass: "metro-list mt-2" },
              [
                _vm._l(_vm.metroNodes, function(node) {
                  return [
                    _c(
                      "div",
                      {
                        key: node.id,
                        staticClass: "metro-square",
                        class: {
                          selected: node.selected,
                          root: node.isRoot,
                          wide: node.state.expanded
                        },
                        on: {
                          click: function($event) {
                            return _vm.nodeClick(node)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "metro-item" }, [
                          _c("div", { staticClass: "metro-label" }, [
                            _vm._m(0, true),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(node.name) +
                                  "\n                            "
                              )
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    node.isRoot
                      ? _c("div", {
                          key: node.id + "afterroot",
                          staticStyle: { width: "100%" }
                        })
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ]
        : [
            _vm._v(
              "\n        Unsupported org component " +
                _vm._s(_vm.orgComponent) +
                "\n    "
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("i", { staticClass: "fa fa-users symbol" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }